import {media} from '@sail/engine';

import {css} from '@sail/ui';

export const styles = {
  container: css({
    display: 'grid',
    justifyItems: 'center',
    alignItems: 'center',
    rowGap: '60px',
  }),
  horizontalLayout: css({
    grid: 'auto / repeat(2, 1fr)',
    [media.up('672px')]: {
      grid: 'auto / repeat(4, 1fr)',
    },
  }),
  verticalLayout: css({
    grid: 'auto / repeat(2, 1fr)',
  }),
};
